import { render, staticRenderFns } from "./ApexGradientDonutChart2.vue?vue&type=template&id=af95496e&"
import script from "./ApexGradientDonutChart2.vue?vue&type=script&lang=js&"
export * from "./ApexGradientDonutChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports